module.exports = __webpack_public_path__ + "static/media/avatar.7a6bc100.jpg";